import axios from 'axios';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

import React, { useEffect, useState } from 'react';

import { toast } from 'react-toastify';

import { useAuth } from '@src/contexts/authContext';
import { CheckboxGroup } from '@src/utils';

const url = `${process.env.REACT_APP_API_URL}`;

export default function EditITSystemNurse({
  openModals,
  setOpenModals,
  fetchData,
}) {
  const { auth } = useAuth();

  const [data, setData] = useState({
    item: '',
    roles: [],
    is_deleted: false,
    extended_item: null,
  });

  const handleType = (value, isChecked) => {
    const currentRoles = Array.isArray(data.roles) ? data.roles : [];

    const updatedRoles = isChecked
      ? [...new Set([...currentRoles, value])]
      : currentRoles.filter((role) => role !== value);

    setData({ ...data, roles: updatedRoles });
  };

  useEffect(() => {
    const fetchDataAsync = async () => {
      if (!openModals) return;

      try {
        const response = await axios.get(
          `${url}/admin/it-system-items/${openModals}`,
          {
            headers: {
              Authorization: `Bearer ${auth.idToken}`,
            },
          },
        );

        const itemData = response.data;

        setData({
          ...itemData,
          roles: Array.isArray(itemData.roles) ? itemData.roles : [],
        });
      } catch (error) {
        console.error('Failed to fetch IT system item:', error);
      }
    };

    fetchDataAsync();
  }, [auth.idToken, openModals]);

  const handlePost = async () => {
    const systemPayload = {
      item: data?.item,
      roles: Array.isArray(data?.roles) ? data.roles : [],
      is_deleted: !!data?.is_deleted,
    };

    const preferencePayload = {
      item: data?.item,
      role: Array.isArray(data?.roles) ? data.roles : [],
      extended_item: {
        id: data?._id,
        model_name: 'ItSystemItem',
      },
    };

    const preferenceId = data?.extended_item?.id;

    try {
      const systemUpdate = axios.put(
        `${url}/admin/it-system-items/${openModals}`,
        systemPayload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.idToken}`,
          },
        },
      );

      const preferenceUpdate = preferenceId
        ? axios.put(`${url}/preferences/${preferenceId}`, preferencePayload, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${auth.idToken}`,
            },
          })
        : null;

      await Promise.all([systemUpdate, preferenceUpdate]);

      toast.success('Item updated successfully', {
        position: 'top-center',
        autoClose: 2000,
      });

      fetchData();
      setOpenModals(false);
    } catch (error) {
      console.error('Update failed:', error);
      toast.error(error.response?.data?.message || 'Failed to update item', {
        position: 'top-center',
        autoClose: 2000,
      });
    }
  };

  return (
    <Dialog
      maxWidth='lg'
      fullwidth
      open={openModals}
      onClose={() => setOpenModals(false)}
    >
      <DialogTitle>Edit IT System Item</DialogTitle>

      <DialogContent>
        <div className='flex justify-between'>
          <Box flex={1} mr={1}>
            <Typography mt={2} fontFamily='Poppins'>
              Name*
            </Typography>
            <TextField
              fullWidth
              variant='outlined'
              placeholder='Enter name'
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '6px',
                },
                mt: '5px',
                width: '400px',
              }}
              value={data?.item || ''}
              onChange={(e) =>
                setData({
                  ...data,
                  item: e.target.value,
                })
              }
            />
          </Box>

          <Box flex={1} mr={1} pt={2}>
            <Typography fontFamily='Poppins'>Role(s)*</Typography>
            <CheckboxGroup
              selectedValues={Array.isArray(data?.roles) ? data.roles : []}
              onChange={handleType}
            />
          </Box>

          <Typography fontSize={12} color='gray' mt={3}>
            Please also edit on Preference!
          </Typography>
        </div>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{ textTransform: 'none' }}
          onClick={() => setOpenModals(false)}
          color='secondary'
        >
          Cancel
        </Button>
        <Button
          sx={{ textTransform: 'none' }}
          color='primary'
          onClick={handlePost}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
